import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    border-bottom: 1pt solid ${colors.softGray};
    color: ${colors.strongGray};
    background-color: 'none';
    align-items: center;
    width: 100%;
    border-radius: 12px;
    padding: 16px;
    border: 1pt solid ${colors.softGray};
    margin: 10px 16px;
    `
export const RowTitle = styled.div`
    display: flex;
    flex-direction: row;
    font-weight: bold;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    width: 30%;
`
export const Title = styled.text`
    font-size: 16px;
    font-weight: bold;
    color: ${colors.titleStrongBlack};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

`
export const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${(props) => props.color[1]};
    color: ${(props) => props.color[0]};
    font-size: 16px;

    @media (max-width: 1200px) {
        display:    none;
    }
`
export const Divisor = styled.div`
    width: 1pt;
    height: 80%;
    background-color: ${colors.softGray};
`

export const TextName = styled.div`
    font-size: 16px;
    color: ${colors.strongGray};
    width: 30%;
    padding-left: 16px;
`
export const DescriptionText = styled.div`
    font-size: 14px;
    color: ${colors.strongGray};
    padding-left: 16px;
    width: ${(props) => (props.isDelay ? '60%' : '70%')}
`
export const DelayCard = styled.div`
    margin-left: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    color: ${colors.strongYellow};
    background-color: ${colors.strongYellow}1A;
    padding: 8px;
    font-size: 14px;
    width: "10%";
`
export const Option = styled.div`
    cursor: pointer;
    margin-left: 16px;
`
